import { request } from '@/shared/api/request'

export interface ClientAPIConfig {
  name: string
  api_type: string
  endpoint: string
  region?: string
  api_key_masked: string
  timeout?: number
  retry_count?: number
  extra_config?: Record<string, any>
}

export interface EncryptedClientAPIConfig {
  name: string
  api_type: string
  endpoint: string
  region?: string
  encrypted_api_key: {
    encrypted_data: string
    iv: string
    algorithm: string
    timestamp: number
  }
  timeout?: number
  retry_count?: number
  extra_config?: Record<string, any>
}

export interface ClientConfigRequest {
  api_types?: string[]
  client_type: string
  client_version?: string
}

export interface ClientConfigResponse {
  success: boolean
  configs: ClientAPIConfig[]
  timestamp: string
  version: string
}

export interface EncryptedClientConfigResponse {
  success: boolean
  configs: EncryptedClientAPIConfig[]
  encryption_key: string
  timestamp: string
  algorithm: string
  version: string
}

export interface ClientConfigAccessLog {
  id: number
  user_id: number
  api_config_id: number
  api_config_name: string
  client_type: string
  client_version?: string
  ip_address?: string
  response_status?: number
  response_time?: number
  accessed_at: string
}

// 客户端配置API
export const clientConfigApi = {
  // 获取客户端配置（脱敏版本）
  getClientConfigs: (data: ClientConfigRequest) => {
    return request.post<ClientConfigResponse>('/client-config/configs', data)
  },

  // 获取加密客户端配置
  getEncryptedClientConfigs: (data: ClientConfigRequest) => {
    return request.post<EncryptedClientConfigResponse>('/client-config/encrypted-configs', data)
  },

  // 根据API名称获取单个配置
  getClientConfigByName: (apiName: string) => {
    return request.get<ClientAPIConfig>(`/client-config/configs/${apiName}`)
  },

  // 根据API类型获取配置
  getClientConfigsByType: (apiType: string) => {
    return request.get<ClientAPIConfig[]>(`/client-config/configs/types/${apiType}`)
  },

  // 解密数据（测试用）
  decryptData: (data: {
    encrypted_data: string
    iv: string
    encryption_key: string
  }) => {
    return request.post<{ success: boolean; decrypted_data: string }>('/client-config/decrypt', data)
  }
}

// 客户端配置管理API（管理员用）
export const clientConfigAdminApi = {
  // 更新客户端配置
  updateClientConfig: (configId: number, data: {
    client_config_enabled?: boolean
    client_endpoint?: string
    client_region?: string
    client_extra_config?: Record<string, any>
  }) => {
    return request.put(`/api-configs/${configId}/client-config`, data)
  },

  // 切换客户端访问状态
  toggleClientAccess: (configId: number) => {
    return request.post<{
      success: boolean
      client_config_enabled: boolean
      message: string
    }>(`/api-configs/${configId}/toggle-client-access`)
  },

  // 获取客户端访问日志
  getClientAccessLogs: (configId: number, params: {
    page?: number
    size?: number
  }) => {
    return request.get<ClientConfigAccessLog[]>(`/api-configs/${configId}/client-access-logs`, { params })
  }
}
